import React from "react";
import { useCaptainTcCardConfig } from "../../hooks/useCaptainTcCardConfig";

const CaptainTCCashbackCardTerms = (props) => {
  const { cards } = useCaptainTcCardConfig();

  return (
    <section
      id="id_ico_about_section"
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <ul className="list-unstyled">
              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
                <h4 className="title_text text-dark mb-3">Captain TC Rewards Programme - Terms & Conditions</h4>
                <p className="text-dark fw-semibold opacity-50 mb-0">Last updated: 6 September 2026</p>
                <p className="text-dark fw-semibold opacity-50 mb-3">TopCoin UK Ltd | Company Registration No. 16483297 | info@topcoinuk.com</p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <div className="card border-0 shadow-sm p-3 mb-4" style={{ backgroundColor: "#f8f9fa" }}>
                  <h5 className="title_text text-dark mb-3">IMPORTANT - YOUR CAPTAIN TC REWARDS WALLET</h5>
                  <p className="info_description text-dark opacity-75 mb-2 fw-bold">
                    Customers who have a valid and active Captain TC Rewards Card should go to their Captain TC Rewards Wallet within the TopCoin UK platform to view their Captain TC Rewards TopCoin progress and the Captain TC rewards they have earned.
                  </p>
                  <p className="info_description text-dark opacity-75 mb-2 fw-bold">
                    Your Captain TC Rewards Wallet is the place where your Captain TC Rewards Card activity, qualifying Captain TC Rewards TopCoin progress and applicable earned rewards are displayed.
                  </p>
                  <p className="info_description text-dark opacity-75 mb-2 fw-bold">
                    Customers are responsible for checking their Captain TC Rewards Wallet for their current Captain TC reward information.
                  </p>
                  <p className="info_description text-dark opacity-75 mb-0 fw-bold">
                    The Captain TC Rewards Wallet is separate from the customer's original TopCoin Wallet and the Captain TC Gold Wallet.
                  </p>
                </div>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">1. About TopCoin UK Ltd</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK Ltd ("TopCoin UK", "we", "us" or "our") is an advertising, loyalty and rewards company registered in England and Wales under company number <strong>16483297</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The <strong>Captain TC Rewards Programme</strong> is operated by TopCoin UK as part of its advertising, promotional, customer-acquisition and loyalty activities.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Captain TC rewards are provided by TopCoin UK to qualifying customers in accordance with these Terms & Conditions.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">2. Captain TC Rewards Card - Required for Captain TC Rewards</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  The <strong>Captain TC Rewards Card</strong> is the qualifying card required to participate in the Captain TC Rewards Programme.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  A customer must have a valid and active Captain TC Rewards Card to receive or qualify for Captain TC Rewards TopCoin; Silver Captain TC Rewards Card rewards; Bronze Captain TC Rewards Card rewards; Gold Captain TC Rewards Card rewards; and Captain TC Gold Card rewards.
                </p>
                <p className="info_description text-dark opacity-50 mb-0 fw-bold">
                  Without a valid and active Captain TC Rewards Card, a customer will not receive Captain TC Rewards TopCoin and will not be eligible for Captain TC Rewards Card rewards or Captain TC Gold Card rewards.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">3. Captain TC Rewards Wallet</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers with a valid and active Captain TC Rewards Card should access their <strong>Captain TC Rewards Wallet</strong> through the TopCoin UK platform to see their Captain TC Rewards activity.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The Captain TC Rewards Wallet may display the customer's active Silver, Bronze or Gold Captain TC Rewards Card; Captain TC Rewards TopCoin progress; progress towards the next 250 Captain TC Rewards TopCoin reward stage; qualifying Captain TC rewards earned; and other relevant Captain TC Rewards Programme information made available by TopCoin UK.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers should regularly check their Captain TC Rewards Wallet to view the rewards they have earned and their current programme progress.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The Captain TC Rewards Wallet does not itself constitute a bank account, payment account or cash balance.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">4. Captain TC Rewards Card Levels</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  There are three Captain TC Rewards Card levels: <strong>Silver Captain TC Rewards Card, Bronze Captain TC Rewards Card and Gold Captain TC Rewards Card</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Each card level provides a different reward value.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  A customer may have <strong>only ONE active Captain TC Rewards Card at any one time</strong>. This means a customer may have Silver OR Bronze OR Gold - not more than one active Captain TC Rewards Card at the same time.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">5. How Captain TC Rewards Cards Are Distributed</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Captain TC Rewards Cards may be distributed to eligible customers through <strong>participating companies, shops and retailers listed or promoted on the TopCoin UK platform</strong> when customers purchase qualifying products from those participating businesses.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The applicable company, shop, retailer, product or promotional offer will identify whether the qualifying customer receives a Silver, Bronze or Gold Captain TC Rewards Card.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where a Captain TC Rewards Card is included with a qualifying product purchase, the card may be provided to the eligible customer <strong>at no additional charge</strong> as part of the applicable Captain TC promotional rewards offer.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The customer purchases the qualifying product from the participating company, shop or retailer. The Captain TC Rewards Card is an additional promotional loyalty and rewards benefit provided in connection with that qualifying purchase.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Participating businesses, qualifying products and available Captain TC Rewards Card levels may vary.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">6. Purchasing a Captain TC Rewards Card Separately</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where this option is made available by TopCoin UK, customers may also <strong>purchase a Captain TC Rewards Card separately through the TopCoin UK platform</strong> without purchasing a qualifying product from a participating company, shop or retailer.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The available Silver, Bronze or Gold Captain TC Rewards Card, applicable purchase price and conditions will be displayed before purchase.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  A separately purchased Captain TC Rewards Card provides access to the applicable Captain TC Rewards Programme benefits in accordance with these Terms & Conditions.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The Captain TC Rewards Card is a <strong>loyalty and rewards programme card</strong>. It is not itself used to pay for products or services.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Customers may use their active Captain TC Rewards Card to qualify for applicable Captain TC rewards when making qualifying purchases or participating in qualifying promotions through the TopCoin UK platform.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">7. Participating Companies, Shops and Retailers</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Participating companies, shops and retailers are businesses participating in qualifying TopCoin UK or Captain TC promotions.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  A participating company, shop or retailer may provide an eligible customer with a Captain TC Rewards Card in connection with a qualifying product purchase. Participating businesses may also make qualifying products, services or promotions available to existing Captain TC Rewards Card holders.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The relevant product listing, in-store promotion, online promotion or other qualifying offer will specify the applicable conditions.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The fact that a company, shop or retailer appears on or is promoted through the TopCoin UK platform does <strong>not automatically mean every product or purchase qualifies for Captain TC rewards</strong>. Only products, transactions or promotional offers specifically identified as qualifying will be eligible.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">8. One Active Captain TC Rewards Card at a Time</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  A customer may register and use <strong>only one active Captain TC Rewards Card at any one time</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  A customer cannot simultaneously operate multiple Silver, Bronze or Gold Captain TC Rewards Cards. For example, while a Silver Captain TC Rewards Card is active, the customer cannot activate a Bronze or Gold Captain TC Rewards Card. The same rule applies to Bronze and Gold Captain TC Rewards Cards.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The current Captain TC Rewards Card must complete its <strong>5,000 Captain TC Rewards TopCoin cycle</strong> before another Captain TC Rewards Card can be activated.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">9. Customer Eligibility</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  To participate in the Captain TC Rewards Programme, a customer must be <strong>18 years of age or over</strong>; have a valid TopCoin UK account; have a valid and active Captain TC Rewards Card; satisfy applicable qualifying purchase or promotional requirements; provide accurate account and registration information; comply with these Terms & Conditions; and satisfy additional requirements displayed for the applicable company, shop, retailer, product, transaction or promotion.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK may carry out reasonable checks to verify eligibility and protect the programme against fraud and misuse.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">10. Captain TC Rewards TopCoin</h5>
                <p className="info_description text-dark opacity-50 mb-2 fw-bold">
                  Only customers with a valid and active Captain TC Rewards Card are eligible to receive Captain TC Rewards TopCoin.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  When an eligible customer receives qualifying TopCoin in their original <strong>TopCoin Wallet</strong>, the customer receives the <strong>same amount as Captain TC Rewards TopCoin</strong>, subject to these Terms & Conditions and the applicable qualifying transaction or promotion.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  For example: <strong>100 qualifying TopCoin in the customer's original TopCoin Wallet = 100 Captain TC Rewards TopCoin.</strong>
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Captain TC Rewards TopCoin is used to measure progress towards rewards under the customer's active Captain TC Rewards Card. The customer's Captain TC Rewards TopCoin progress can be viewed in their <strong>Captain TC Rewards Wallet</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Captain TC Rewards TopCoin cannot be purchased directly with cash. Captain TC Rewards TopCoin itself is not cash and has no standalone cash value.
                </p>
                <p className="info_description text-dark opacity-50 mb-0 fw-bold">
                  Customers without a valid and active Captain TC Rewards Card will not receive Captain TC Rewards TopCoin.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">11. Silver Captain TC Rewards Card</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  A customer with an active <strong>Silver Captain TC Rewards Card</strong> becomes eligible for a <strong>£2.50 reward for every 250 Captain TC Rewards TopCoin</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The Silver Card cycle continues until <strong>5,000 Captain TC Rewards TopCoin</strong>. There are up to <strong>20 qualifying reward stages</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2 fw-bold">
                  250 Captain TC Rewards TopCoin = £2.50 reward<br />
                  5,000 Captain TC Rewards TopCoin = 20 x £2.50 = £50 maximum scheduled reward value.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Qualifying earned rewards can be viewed through the customer's <strong>Captain TC Rewards Wallet</strong>.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">12. Bronze Captain TC Rewards Card</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  A customer with an active <strong>Bronze Captain TC Rewards Card</strong> becomes eligible for a <strong>£5 reward for every 250 Captain TC Rewards TopCoin</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The Bronze Card cycle continues until <strong>5,000 Captain TC Rewards TopCoin</strong>. There are up to <strong>20 qualifying reward stages</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2 fw-bold">
                  250 Captain TC Rewards TopCoin = £5 reward<br />
                  5,000 Captain TC Rewards TopCoin = 20 x £5 = £100 maximum scheduled reward value.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Qualifying earned rewards can be viewed through the customer's <strong>Captain TC Rewards Wallet</strong>.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">13. Gold Captain TC Rewards Card</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  A customer with an active <strong>Gold Captain TC Rewards Card</strong> becomes eligible for a <strong>£12.50 reward for every 250 Captain TC Rewards TopCoin</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The Gold Card cycle continues until <strong>5,000 Captain TC Rewards TopCoin</strong>. There are up to <strong>20 qualifying reward stages</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2 fw-bold">
                  250 Captain TC Rewards TopCoin = £12.50 reward<br />
                  5,000 Captain TC Rewards TopCoin = 20 x £12.50 = £250 maximum scheduled reward value.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Qualifying earned rewards can be viewed through the customer's <strong>Captain TC Rewards Wallet</strong>.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">14. Completion at 5,000 Captain TC Rewards TopCoin</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Each Captain TC Rewards Card cycle continues until the customer reaches <strong>5,000 Captain TC Rewards TopCoin</strong> on that card.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Once 5,000 Captain TC Rewards TopCoin has been reached and all applicable qualifying rewards have been processed, that card's reward cycle is considered <strong>completed</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  The completed cycle and applicable reward information may be displayed in the customer's Captain TC Rewards Wallet.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">15. Purchasing and Starting a New Captain TC Rewards Card</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  After completing a 5,000 Captain TC Rewards TopCoin cycle, the customer may <strong>purchase and activate a new Captain TC Rewards Card</strong> and begin a new reward cycle.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Subject to availability, applicable prices and eligibility requirements, the customer may choose a new Silver, Bronze or Gold Captain TC Rewards Card. The customer does not have to choose the same card level as their previous card.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The new Captain TC Rewards Card begins a <strong>new Captain TC Rewards TopCoin cycle from zero</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2 fw-bold">
                  Captain TC Rewards TopCoin accumulated under the completed card cannot be transferred, duplicated or carried forward to the new card.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Only one Captain TC Rewards Card may be active at any one time.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">16. Captain TC Gold Cards</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Captain TC Gold Cards are separate collectible cards within the Captain TC Rewards Programme.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  A <strong>Captain TC Gold Card</strong> is different from a <strong>Gold Captain TC Rewards Card</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers may collect qualifying Captain TC Gold Cards through participating companies, shops and retailers, qualifying purchases, TopCoin UK promotions or other qualifying activities specified by TopCoin UK.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Each qualifying Captain TC Gold Card must be successfully registered in the customer's <strong>Captain TC Gold Wallet</strong>. Each unique Captain TC Gold Card and unique serial number may only be registered once.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">17. Captain TC Gold Wallet</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  The <strong>Captain TC Gold Wallet</strong> is used to record qualifying Captain TC Gold Cards registered by the customer.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The Captain TC Gold Wallet is separate from the original TopCoin Wallet and the Captain TC Rewards Wallet.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Customers should use their Captain TC Gold Wallet to view their qualifying registered Captain TC Gold Cards and applicable Gold Card progress.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">18. Active Captain TC Rewards Card Required for Captain TC Gold Card Rewards</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  A customer must have a <strong>valid and active Captain TC Rewards Card</strong> to qualify for Captain TC Gold Card rewards.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The active Captain TC Rewards Card may be Silver, Bronze or Gold.
                </p>
                <p className="info_description text-dark opacity-50 mb-0 fw-bold">
                  Without a valid and active Captain TC Rewards Card, collecting, registering or possessing Captain TC Gold Cards does not make the customer eligible for Captain TC Gold Card rewards.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">19. 20 Captain TC Gold Cards - £16 Reward</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  A customer who has a valid and active Captain TC Rewards Card and successfully collects and registers <strong>20 qualifying Captain TC Gold Cards</strong> becomes eligible for a <strong>£16 reward</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The 20 cards must be valid, unique and successfully registered in the customer's Captain TC Gold Wallet.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Once the 20 Captain TC Gold Cards have been used to claim the £16 reward, those cards are considered used and <strong>cannot be used again towards another reward claim</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where further £16 reward claims are available, the customer must collect and register a new set of 20 qualifying Captain TC Gold Cards.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">20. The Three Wallets</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  For clarity, the Captain TC Rewards Programme may operate alongside three separate wallet functions:
                </p>
                <ul className="info_description text-dark opacity-50 mb-2">
                  <li><strong>TopCoin Wallet</strong> - records the customer's qualifying original TopCoin.</li>
                  <li><strong>Captain TC Rewards Wallet</strong> - displays the customer's active Captain TC Rewards Card, Captain TC Rewards TopCoin progress and applicable Captain TC Rewards Card rewards earned.</li>
                  <li><strong>Captain TC Gold Wallet</strong> - records qualifying Captain TC Gold Cards registered by the customer and applicable Gold Card progress.</li>
                </ul>
                <p className="info_description text-dark opacity-50 mb-0">
                  Customers should use the appropriate wallet to check the relevant programme information.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">21. How Rewards Are Provided</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Captain TC rewards are promotional rewards provided by <strong>TopCoin UK Ltd</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Depending on availability, rewards may include gift cards, eGift cards, vouchers, products, promotional benefits or other reward options made available by TopCoin UK.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where customers are offered a choice of rewards from participating companies, shops, retailers or other brands, available options may be displayed through the TopCoin UK platform or applicable Captain TC Rewards Wallet.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Third-party rewards may be subject to the relevant provider's own terms, restrictions and expiry dates.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">22. Qualifying Transactions and Promotions</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Captain TC Rewards TopCoin and Captain TC Gold Cards will only be awarded or recognised in connection with qualifying purchases, transactions, activities or promotions specified by TopCoin UK.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Not every purchase from a participating company, shop or retailer will necessarily qualify.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The applicable product listing, in-store promotion, online offer or promotional material will specify the relevant qualifying requirements and Captain TC benefits.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK may apply a reasonable validation period before TopCoin, Captain TC Rewards TopCoin, Captain TC Gold Cards or associated rewards are confirmed.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">23. Returns, Refunds, Cancellations and Reversed Transactions</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  If a qualifying transaction is subsequently cancelled, returned, refunded, reversed, charged back or determined to be invalid, TopCoin UK may remove or adjust corresponding <strong>TopCoin, Captain TC Rewards TopCoin, Captain TC Gold Cards or unissued reward eligibility</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Any corresponding adjustment may also be reflected in the customer's applicable wallet.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Nothing in these Terms affects the customer's statutory consumer rights concerning the underlying purchase.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">24. Reward Claims and Verification</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers must satisfy all applicable qualifying requirements before becoming eligible for a Captain TC reward.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Each qualifying <strong>250 Captain TC Rewards TopCoin stage</strong> may generate only one applicable Silver, Bronze or Gold Captain TC Rewards Card reward.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Each Captain TC Gold Card may only be registered once and counted in accordance with the applicable programme rules.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK may verify qualifying transactions, account details, card numbers, unique serial numbers and programme activity before confirming or issuing rewards.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">25. No Standalone Cash Value</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Captain TC Rewards Cards, Captain TC Gold Cards and Captain TC Rewards TopCoin have <strong>no standalone cash value</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  They cannot themselves be exchanged or sold back to TopCoin UK for cash.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  They form part of the Captain TC promotional loyalty and rewards programme and are used to establish programme eligibility and progress towards applicable rewards.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">26. Non-Transferability</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  An active Captain TC Rewards Card is personal to the customer and the TopCoin UK account to which it is registered.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Once registered, it may not be sold or transferred to another customer.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  TopCoin UK may impose reasonable restrictions on the transfer or registration of Captain TC Gold Cards and other programme benefits where necessary to protect the programme and prevent fraud or misuse.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">27. Fraud, Multiple Accounts and Misuse</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Customers must not create multiple accounts for improper purposes, use another person's details, manipulate purchases or transactions, or otherwise attempt to obtain Captain TC Rewards Cards, Captain TC Rewards TopCoin, Captain TC Gold Cards or rewards improperly.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may investigate suspected fraud, abuse or manipulation.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where fraud or material misuse is reasonably established, TopCoin UK may withhold affected rewards, remove incorrectly awarded benefits, suspend programme participation or close the relevant account.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">28. Lost, Damaged or Replacement Captain TC Rewards Cards</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where an active Captain TC Rewards Card is lost, damaged or defective, the customer should contact TopCoin UK.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may issue or authorise a replacement where appropriate.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  A replacement card does <strong>not</strong> create a new 5,000 Captain TC Rewards TopCoin cycle. The customer's existing progress and applicable reward limits continue under the replacement card.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">29. Participating Companies, Shops and Retailers</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Participating companies, shops and retailers may sell qualifying products, participate in qualifying Captain TC promotions and distribute Captain TC Rewards Cards.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Unless expressly stated otherwise, <strong>Captain TC Rewards Programme rewards are administered by TopCoin UK and subject to these Terms & Conditions</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  The participating company, shop or retailer remains responsible for the underlying product sale and may have its own applicable terms concerning payment, delivery, returns, refunds and warranties.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Nothing in the Captain TC Rewards Programme affects a customer's statutory rights concerning the underlying purchase.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">30. Reward Availability</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  Available Captain TC reward options may change from time to time.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where a particular third-party reward becomes unavailable, TopCoin UK may provide an alternative reward of equivalent value where reasonably necessary.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Availability of a particular company, shop, retailer, gift card, voucher, product or third-party reward should not be considered permanent unless expressly stated.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">31. Personal Information</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK processes personal information in accordance with its Privacy Policy and applicable data-protection law.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Personal information may be processed for purposes including account administration, card registration, wallet operation, reward fulfilment, customer support, transaction verification, security, fraud prevention and legal compliance.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">32. Changes to the Captain TC Rewards Programme</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK may make reasonable changes to the Captain TC Rewards Programme and these Terms & Conditions.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Where a material change affects existing customers, appropriate notice will be provided where required.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK will not retrospectively remove a reward that a customer has already validly qualified for and claimed solely because these Terms are subsequently changed.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  A new Captain TC Rewards Card purchased following completion of a previous card will be subject to the prices, reward rates, eligibility requirements and Terms & Conditions applicable when the new card is purchased and activated.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">33. Our Responsibility</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  TopCoin UK will operate the Captain TC Rewards Programme with reasonable care and skill.
                </p>
                <p className="info_description text-dark opacity-50 mb-2">
                  Nothing in these Terms excludes or restricts liability where doing so would be unlawful. Nothing in these Terms affects a customer's statutory consumer rights.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Where third parties provide gift cards, vouchers, products or other reward fulfilment, the relevant provider's additional terms may apply.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">34. Governing Law</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  These Terms & Conditions are governed by the <strong>laws of England and Wales</strong>.
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  Customers may also have mandatory consumer rights under the laws applicable where they live.
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <h5 className="title_text text-dark mt-3">35. Contact Us</h5>
                <p className="info_description text-dark opacity-50 mb-2">
                  For questions about the Captain TC Rewards Programme:
                </p>
                <p className="info_description text-dark opacity-50 mb-0">
                  <strong>TopCoin UK Ltd</strong><br />
                  Company Registration No.: 16483297<br />
                  Email: <strong>info@topcoinuk.com</strong>
                </p>
              </li>

              <li data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" className="py-2">
                <div className="card border-0 shadow-sm p-3 mt-4" style={{ backgroundColor: "#f8f9fa" }}>
                  <h5 className="title_text text-dark mb-3">IMPORTANT CUSTOMER INFORMATION</h5>
                  <p className="info_description text-dark opacity-75 mb-2">
                    <strong>Captain TC Rewards Card Required:</strong> You must have a valid and active Captain TC Rewards Card to receive Captain TC Rewards TopCoin and participate in the applicable Captain TC reward benefits.
                  </p>
                  <p className="info_description text-dark opacity-75 mb-2">
                    <strong>Check Your Captain TC Rewards Wallet:</strong> If you have a Captain TC Rewards Card, go to your Captain TC Rewards Wallet to see your Captain TC Rewards TopCoin progress and the rewards you have earned.
                  </p>
                  <p className="info_description text-dark opacity-75 mb-2">
                    <strong>One Active Card:</strong> You may have only ONE active Captain TC Rewards Card at a time: Silver OR Bronze OR Gold.
                  </p>
                  <p className="info_description text-dark opacity-75 mb-2">
                    <strong>5,000 Captain TC Rewards TopCoin:</strong> Once your card reaches 5,000 Captain TC Rewards TopCoin, that card's reward cycle is completed. You may then purchase and activate a new Silver, Bronze or Gold Captain TC Rewards Card and start a new cycle from zero.
                  </p>
                  <p className="info_description text-dark opacity-75 mb-0">
                    <strong>Captain TC Gold Cards:</strong> Captain TC Gold Cards are separate from the Gold Captain TC Rewards Card. A customer must have a valid and active Captain TC Rewards Card to qualify for Captain TC Gold Card rewards. 20 qualifying Captain TC Gold Cards = £16 reward, subject to these Terms & Conditions.
                  </p>
                </div>
              </li>

            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaptainTCCashbackCardTerms;
